import { type CreateUserModel, type DatosBOExternoModel, type DetailUsuarioModel } from '@api/api';

export class CreateUsuario implements CreateUserModel {

  Nombre: string = '';
  Apellidos: string = '';
  Email: string = '';
  Documento: string | null = null;
  Telefono: string | null = null;
  IdEmpresaAgentes: string | null = null;
  Roles: string[] = [];
  Validado: boolean | null = false;
  DatosBOExterno: DatosBOExternoModel | null = null;
  IdsDelegacionInmobiliaria: string[] = [];
  
  constructor(data?: Partial<CreateUsuario>) {
    Object.assign(this, data);
  }

  public createFromUsuarioDetail(usuario: DetailUsuarioModel): CreateUsuario{
    Object.assign(this, usuario);
    return this;
  }

}